import { Controller } from "@hotwired/stimulus"

// highlight.js コアのみロードし、必要な言語だけ登録してバンドルサイズを抑える
import hljs from "highlight.js/lib/core"
import ruby       from "highlight.js/lib/languages/ruby"
import javascript from "highlight.js/lib/languages/javascript"
import python     from "highlight.js/lib/languages/python"
import bash       from "highlight.js/lib/languages/bash"
import sql        from "highlight.js/lib/languages/sql"
import css        from "highlight.js/lib/languages/css"
import xml        from "highlight.js/lib/languages/xml"  // HTML/ERB
import json       from "highlight.js/lib/languages/json"

hljs.registerLanguage("ruby",       ruby)
hljs.registerLanguage("javascript", javascript)
hljs.registerLanguage("js",         javascript)
hljs.registerLanguage("python",     python)
hljs.registerLanguage("bash",       bash)
hljs.registerLanguage("shell",      bash)
hljs.registerLanguage("sh",         bash)
hljs.registerLanguage("sql",        sql)
hljs.registerLanguage("css",        css)
hljs.registerLanguage("html",       xml)
hljs.registerLanguage("xml",        xml)
hljs.registerLanguage("erb",        xml)
hljs.registerLanguage("json",       json)

// SVG アイコン定数（ファイル上部で定義して再利用）
const COPY_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"/></svg>`

// Turbo Stream でメッセージが DOM に挿入されるたびに connect() が呼ばれ、
// シンタックスハイライトとコピーボタンが自動適用される
export default class extends Controller {
  connect() {
    this.highlightAndDecorate()
  }

  highlightAndDecorate() {
    this.element.querySelectorAll("pre code").forEach(block => {
      // 二重処理を防ぐ（hljs が data-highlighted="yes" を付与する）
      if (block.dataset.highlighted) return

      // 言語名を hljs 処理前に取得（クラス名が変わる前）
      const lang = this.detectLang(block)

      // シンタックスハイライト適用
      hljs.highlightElement(block)

      // ヘッダー（言語ラベル + コピーボタン）付きラッパーで囲む
      this.wrapWithHeader(block.parentElement, lang)
    })
  }

  // <code> 要素のクラス名から言語名を抽出
  // Redcarpet: class="ruby"  /  標準: class="language-ruby"
  detectLang(block) {
    for (const cls of block.classList) {
      if (cls === "hljs") continue
      if (cls.startsWith("language-")) return cls.replace("language-", "")
      if (cls.trim()) return cls  // Redcarpet の裸クラス名（"ruby" 等）
    }
    return ""
  }

  // <pre> をヘッダー付きラッパーで囲む
  wrapWithHeader(pre, lang) {
    // 既にラップ済みならスキップ
    if (pre.parentElement?.classList.contains("code-block-wrapper")) return

    // ── ラッパー div ──────────────────────────────────────
    const wrapper = document.createElement("div")
    wrapper.className = "code-block-wrapper"
    wrapper.setAttribute("data-controller", "clipboard")

    // ── ヘッダーバー（言語名 + コピーボタン）──────────────
    const header = document.createElement("div")
    header.className = "code-block-header"
    header.innerHTML = `
      <span class="code-block-lang">${lang || "code"}</span>
      <button
        type="button"
        data-action="click->clipboard#copy"
        class="code-block-copy-btn"
        title="コードをコピー"
      >
        ${COPY_ICON_SVG}
        <span data-clipboard-target="label">Copy</span>
      </button>
    `

    // ── DOM 組み替え ──────────────────────────────────────
    pre.parentNode.insertBefore(wrapper, pre)
    wrapper.appendChild(header)
    wrapper.appendChild(pre)
  }
}
